
import React from 'react';
import { Button } from "@/components/ui/button";
import { BrainCircuit, ActivitySquare } from 'lucide-react';
import { Link } from 'react-router-dom';

interface MaintenanceHeaderProps {
  title: string;
}

const MaintenanceHeader = ({ title }: MaintenanceHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
      <h2 className="text-xl font-semibold">{title}</h2>
      <div className="mt-2 sm:mt-0">
        <Link to="/energy/analytics" state={{ tab: "aiAdvisory", subTab: "maintenance" }}>
          <Button variant="outline" size="sm" className="mr-2">
            <BrainCircuit className="mr-2 h-4 w-4" />
            View AI Dashboard
          </Button>
        </Link>
        <Button variant="default" size="sm">
          <ActivitySquare className="mr-2 h-4 w-4" />
          Run Diagnostics
        </Button>
      </div>
    </div>
  );
};

export default MaintenanceHeader;
